import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaRainbow } from 'react-icons/fa';

const games = [
  {
    id: 'rainbow-dance',
    name: 'Rainbow Dance Party',
    description: 'A fun dance game where kids follow colorful patterns with their hands and feet',
    difficulty: 'Easy',
    ageRange: '3-10 years',
    setupTime: '5-10 minutes'
  }
];

export default function DiyActivities() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      console.log('DiyActivities component mounted');
      
      // Simulate potential error scenarios
      if (!games || games.length === 0) {
        console.warn('No games found in DiyActivities');
        setError('No DIY activities available');
      }
      if (!games || games.length === 0) {
        console.warn('No DIY activities found');
        setError('No DIY activities available');
      }
    } catch (err) {
      console.error('Error in DiyActivities component:', err);
      setError('Failed to load DIY activities');
    }
  }, []);

  if (error) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-8 text-center text-red-600">
          <h2 className="text-2xl font-bold mb-4">Oops! Something went wrong</h2>
          <p>{error}</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="sm:flex sm:items-center mb-6">
          <div className="sm:flex-auto">
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">DIY Activities</h1>
            <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
              Interactive games and activities you can play with your children
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {games.map((game) => (
            <Link
              key={game.id}
              to={`/diy-activities/${game.id}`}
              className="group relative bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden hover:shadow-lg transition-shadow duration-200"
              onError={(e) => {
                console.error('Error in game link:', e);
                setError(`Failed to load game: ${game.name}`);
              }}
            >
              <div className="aspect-w-16 aspect-h-9 bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                {game.id === 'rainbow-dance' ? (
                  <FaRainbow className="w-16 h-16 text-rainbow-500 opacity-70" />
                ) : (
                  <div className="text-gray-500 dark:text-gray-400">
                    No Image Available
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                  {game.name}
                </h3>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  {game.description}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                    {game.difficulty}
                  </span>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                    {game.ageRange}
                  </span>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200">
                    Setup: {game.setupTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}